var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-40px lg:pt-100px",attrs:{"id":"ProductDetails"}},[_c('editor-image',{attrs:{"name":"imageSection"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }